"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const default_session_1 = require("../../../../session/default-session");
const metadata_provider_1 = require("../metadata-provider");
function Definition(params) {
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const metadataProvider = new metadata_provider_1.MetadataProvider(session);
            return metadataProvider.getViewlist(params);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy9tZXRhZGF0YS92aWV3bGlzdC9kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHlFQUFpRTtBQUNqRSw0REFBd0Q7QUFFeEQsU0FBZ0IsVUFBVSxDQUFDLE1BQWtEO0lBQ3pFLE9BQU87UUFDSCxPQUFPLENBQUMsVUFBbUIsSUFBQSw0QkFBVSxHQUFFO1lBQ25DLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxvQ0FBZ0IsQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUV2RCxPQUFPLGdCQUFnQixDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUNoRCxDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUFSRCxnQ0FRQyJ9